import React from 'react'
import { Typography, Row, Col, Card, Tag } from 'antd'
const { Paragraph } = Typography

const ServiceOverview = () => {
	return (
		<div style={{ marginBottom: 32 }}>
			<Paragraph>
				We provide tailored service packages to match your business
				needs. Whether it's a one-time request or a full-scale
				engagement, our team leverages{' '}
				<strong>advanced automations</strong> and{' '}
				<strong>AI agents</strong> to deliver results at a speed and
				quality unmatched by traditional teams.
			</Paragraph>
			<Paragraph>
				For perspective: <strong>1 hour of our service</strong> equals
				approximately{' '}
				<strong>8 hours of work from a junior team member</strong>.
			</Paragraph>

			<Row gutter={[16, 16]}>
				<Col xs={24} sm={12} md={6}>
					<Card
						type="inner"
						hoverable
						variant="outlined"
						title="One-Time"
						extra={<Tag color="blue">On-Demand</Tag>}
					>
						Ideal for urgent or one-off needs. Pay per task with no
						recurring commitment.
					</Card>
				</Col>
				<Col xs={24} sm={12} md={6}>
					<Card
						type="inner"
						hoverable
						title="Lite"
						extra={<Tag color="green">1h / Day</Tag>}
					>
						Light support with daily 1-hour execution. Fast output
						powered by our automation stack.
					</Card>
				</Col>
				<Col xs={24} sm={12} md={6}>
					<Card
						type="inner"
						hoverable
						title="Core"
						extra={<Tag color="orange">4h / Day</Tag>}
					>
						Balanced daily service for steady operational needs.
						Reliable and efficient.
					</Card>
				</Col>
				<Col xs={24} sm={12} md={6}>
					<Card
						type="inner"
						hoverable
						title="Edge"
						extra={<Tag color="red">8h / Day</Tag>}
					>
						Full-scale daily engagement. Maximum output with
						top-priority execution.
					</Card>
				</Col>
			</Row>
		</div>
	)
}

export default ServiceOverview
